import {ref, Ref, watch} from 'vue';

/** POC for a custom composable for using cache, as pinia-persisted-state is buggy */
export function useCachedValue<T>(target: string, defaultValue: T) {
    const targetRef = ref(defaultValue) as Ref<T>;

    function deserializeItem(): T | string | undefined {
        const item = sessionStorage.getItem(target);

        if (item) {
            try {
                const parsed = JSON.parse(item);
                return parsed as T;
            } catch (e) {
                return item;
            }
        }
    }

    function read(newValue?: T, oldValue?: T) {
        const storedValue = deserializeItem();
        if (newValue != null) {
            const serializedValue = JSON.stringify(newValue);
            sessionStorage.setItem(target, serializedValue);
        } else {
            if (oldValue != null && storedValue) {
                sessionStorage.removeItem(target);
            } else {
                targetRef.value = (storedValue as T) ?? defaultValue;
            }
        }
    }

    watch(targetRef, read);

    read();

    return targetRef;
}
